import { combineReducers } from 'redux';

const noticeInitialState = {
  loadStatus: 0,
  didLoadAt: 0,
  list: null,
};

function noticeReducer(state = noticeInitialState, action) {
  switch (action.type) {
    case 'LOAD_NOTICE_LIST': {
      return {
        ...state,
        loadStatus: 1,
      };
    }

    case 'LOAD_NOTICE_LIST_COMPLETION': {
      if (action.error) {
        return {
          ...state,
          loadStatus: 0,
        };
      }

      return {
        ...state,
        loadStatus: 2,
        didLoadAt: action.didLoadAt,
        list: action.list,
      };
    }

    case 'SHIFT_NOTICE': {
      if (!state.list) {
        return state;
      }

      return {
        ...state,
        list: state.list.slice(1),
      };
    }

    default:
      return state;
  }
}

export default combineReducers({
  notice: noticeReducer,
});
